import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiResponse, HorarioRecojoPorIdSucursalDto, SucursalRecojoDto } from '../dto';
import { handleApiError, normalizeHttpError } from '../utils';

@Injectable()
export class WsSucursalRecojoService {
	private endpoint = `/api/WsSucursalRecojo`;
	private genHeader = { context: '.tab-content' };
	constructor(private http: HttpClient, private handler: HttpBackend) { }

	getAll(skipLoading: boolean = true): Observable<ApiResponse<SucursalRecojoDto[]>> {
		const headers = {
			'skip-loading': skipLoading ? 'true' : 'false'
		};
		return this.http.get<ApiResponse<SucursalRecojoDto[]>>(
			`${this.endpoint}/listar`,
			{ headers }
		).pipe(
			catchError(handleApiError<SucursalRecojoDto[]>())
		);
	}

	get(IdSucursalRecojo: number): Observable<ApiResponse<SucursalRecojoDto>> {
		return this.http.get<ApiResponse<SucursalRecojoDto>>(
			`${this.endpoint}/${IdSucursalRecojo}`
		).pipe(
			catchError(handleApiError<SucursalRecojoDto>())
		);
	}

	getHorarios(IdSucursalRecojo: number): Observable<ApiResponse<HorarioRecojoPorIdSucursalDto[]>> {
		return this.http.get<ApiResponse<HorarioRecojoPorIdSucursalDto[]>>(
			`${this.endpoint}/${IdSucursalRecojo}/horarios`
		).pipe(
			catchError(handleApiError<HorarioRecojoPorIdSucursalDto[]>())
		);
	}
}
